import React from "react";
import "../styles.css";

const SkeletonCard = () => {
  return (
    <div className="fila-licitacion" style={{ border: 'none', cursor: 'default' }}>
      <div className="col-expediente skeleton" style={{ height: '20px', width: '80%' }}></div>
      <div className="col-titulo skeleton" style={{ height: '20px', width: '90%' }}></div>
      <div className="col-organismo skeleton" style={{ height: '20px', width: '70%' }}></div>
      <div className="col-presupuesto skeleton" style={{ height: '20px', width: '65%' }}></div>
      <div className="col-fecha skeleton" style={{ height: '20px', width: '60%' }}></div>
      <div className="col-estado skeleton" style={{ height: '24px', width: '80px', borderRadius: '99px' }}></div>
      <div className="col-boton skeleton" style={{ height: '32px', width: '32px', borderRadius: '50%' }}></div>
    </div>
  );
};

export default SkeletonCard;
